'use client';

import React from 'react';
import ViewType1 from './viewTypes/ViewType1';
import ViewType2 from './viewTypes/ViewType2';
import ViewType3 from './viewTypes/ViewType3';
import ViewType4 from './viewTypes/ViewType4';
import ViewType5 from './viewTypes/ViewType5';
import { CaseStudyFeature } from '../../../constants/types';


interface FeatureProps {
  features: CaseStudyFeature[];
}

const Feature: React.FC<FeatureProps> = ({ 
  features, 
}) => {
  return (
    <>
      {features?.map((feature, index) => {
        const key = `${feature.viewType}-${index}`;
        
        switch (feature.viewType) {
          case 'view1':
            return <ViewType1 item={feature} key={key} />;
          case 'view2':
            return <ViewType2 item={feature} key={key} />;
          case 'view3':
            return <ViewType3 item={feature} key={key} />;
          case 'view4':
            return <ViewType4 item={feature} key={key} />;
          case 'view5':
            return <ViewType5 item={feature} key={key} />;
          default:
            return null;
        }
      })}
    </>
  );
};

export default Feature
